<template>
  <v-card
    tile
    flat
    color="grey lighten-5"
    v-if="loggedInUser != null && this.pagePermission == true"
  >
    <v-container>
      <v-alert v-if="successMessage != null" dense text type="success">
        {{ successMessage }}
      </v-alert>
      <v-alert v-if="errorMessage != null" dense outlined type="error">
        {{ errorMessage }}
      </v-alert>
      <v-row align="center" dense no-gutters>
        {{
          formatDate(currentWeek[0], 'MMM. D') +
            ' ~ ' +
            formatDate(currentWeek[1], 'MMM. D')
        }}
        {{
          teamView == false
            ? ' (' + taskBalances.totalHours.toFixed(2) + ' hours)'
            : ''
        }}
        <v-tooltip right v-if="setUser != null && teamView == true">
          <template v-slot:activator="{ on, attrs }">
            <v-chip v-bind="attrs" v-on="on" class="ma-2" small>
              {{
                userStoreData[setUser].name.split(' ')[0][0] +
                  userStoreData[setUser].name.split(' ')[1][0]
              }}
            </v-chip>
          </template>
          <span>{{ userStoreData[setUser].name }}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <!-- <v-switch
          v-model="teamView"
          v-if="loggedInUser.type == 'Admin'"
          class="mx-2"
          color="primary"
          label="Team"
        ></v-switch> -->
      </v-row>
      <v-row v-if="teamView == true">
        <v-tooltip right v-for="(uId, t) in Object.keys(timeBalances)" :key="t">
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              v-bind="attrs"
              v-on="on"
              class="ma-2"
              small
              @click.stop="setUser = uId"
            >
              {{
                userStoreData[uId].name.split(' ')[0][0] +
                  userStoreData[uId].name.split(' ')[1][0] +
                  ': ' +
                  timeBalances[uId].toFixed(2) +
                  ' hours'
              }}
            </v-chip>
          </template>
          <span>{{ userStoreData[uId].name }}</span>
        </v-tooltip>
        <v-chip class="ma-2" small @click.stop="setUser = null">
          All
        </v-chip>
      </v-row>
      <v-row>
        <v-col cols="12" v-for="(taskId, i) in sortedTasks" :key="i">
          <v-card>
            <v-card-title>
              <span class="subtitle-2"
                >{{ projectStoreData[taskStoreData[taskId].projectId].name }} :
                {{ taskStoreData[taskId].name }}
              </span>
              <v-spacer></v-spacer>
              <span class="subtitle-2"
                >{{
                  formatDate(
                    taskStoreData[taskId].completionDate,
                    'ddd, MMM. D'
                  )
                }}
              </span>
            </v-card-title>
            <v-card-subtitle>
              {{ taskStoreData[taskId].description }}
            </v-card-subtitle>
            <v-card-text>
              <v-row dense no-gutters>
                <span class="subtitle-2">{{
                  taskBalances[taskId].hours.toFixed(2) + ' hours'
                }}</span>
                <v-spacer></v-spacer>
                <v-tooltip
                  left
                  v-for="(uId, t) in taskStoreData[taskId].team"
                  :key="t"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip v-bind="attrs" v-on="on" class="ma-2" x-small>
                      {{
                        userStoreData[uId].name.split(' ')[0][0] +
                          userStoreData[uId].name.split(' ')[1][0]
                      }}
                    </v-chip>
                  </template>
                  <span>{{ userStoreData[uId].name }}</span>
                </v-tooltip>
              </v-row>
              <v-divider></v-divider>
              <v-expansion-panels flat>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-row no-gutters align="center">
                      <v-col cols="4">
                        <v-menu
                          bottom
                          offset-y
                          transition="slide-y-transition"
                          v-if="teamView != true"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              rounded
                              class="ma-2"
                              outlined
                              color="green lighten-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon left>mdi-plus</v-icon> Submit
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item>
                              <v-btn
                                small
                                text
                                color="primary"
                                @click.stop="
                                  loadTimeForm('Add', {
                                    taskId: taskId,
                                    projectId: taskStoreData[taskId].projectId,
                                    serviceType:
                                      taskStoreData[taskId].serviceType,
                                  })
                                "
                              >
                                Time
                              </v-btn>
                              <v-btn
                                small
                                text
                                color="primary"
                                @click.stop="
                                  loadExpenseForm('Add', {
                                    taskId: taskId,
                                    projectId: taskStoreData[taskId].projectId,
                                    serviceType:
                                      taskStoreData[taskId].serviceType,
                                  })
                                "
                              >
                                Expense
                              </v-btn>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-spacer></v-spacer>
                      <span class="overline">
                        Submissions
                      </span>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col>
                        <span class="overline">Time</span>
                      </v-col>
                    </v-row>
                    <v-card
                      flat
                      tile
                      light
                      v-for="(timeSub, j) in timeSubsByTask[taskId]"
                      :key="j"
                    >
                      <v-card-title>
                        <v-row align="center" no-gutters>
                          <v-col cols="5">
                            <span class="subtitle-2">
                              {{
                                formatDate(
                                  timeSubmissionStoreData[timeSub.id].date,
                                  'ddd, MMM. D'
                                )
                              }}
                            </span>
                          </v-col>
                          <v-col cols="5">
                            <span class="subtitle-2">
                              {{
                                timeSubmissionStoreData[
                                  timeSub.id
                                ].duration.toFixed(2)
                              }}
                              hours
                            </span>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                x-small
                                icon
                                class="ma-2"
                                color="primary"
                                @click.stop="
                                  loadTimeForm(
                                    'Edit',
                                    timeSubmissionStoreData[timeSub.id]
                                  )
                                "
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit Time Submission</span>
                          </v-tooltip>
                        </v-row>
                      </v-card-title>
                      <v-card-subtitle>
                        <v-row dense no-gutters align="center">
                          <v-tooltip
                            right
                            v-if="
                              timeSubmissionStoreData[timeSub.id].s3FilePath !=
                                null
                            "
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                x-small
                                icon
                                class="ma-2"
                                color="primary"
                                @click.stop="
                                  getSubmissionImage(
                                    timeSubmissionStoreData[timeSub.id]
                                  )
                                "
                              >
                                <v-icon>{{
                                  timeSubmissionStoreData[
                                    timeSub.id
                                  ].s3FileContentType.split('/')[0] == 'image'
                                    ? 'mdi-image'
                                    : 'mdi-paperclip'
                                }}</v-icon>
                              </v-btn>
                            </template>
                            <span>View Attachment</span>
                          </v-tooltip>
                          {{ timeSubmissionStoreData[timeSub.id].description }}
                          <v-spacer></v-spacer>
                          <v-tooltip left v-if="teamView == true">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                class="ma-2"
                                x-small
                              >
                                {{
                                  userStoreData[timeSub.userId].name.split(
                                    ' '
                                  )[0][0] +
                                    userStoreData[timeSub.userId].name.split(
                                      ' '
                                    )[1][0]
                                }}
                              </v-chip>
                            </template>
                            <span>{{
                              userStoreData[timeSub.userId].name
                            }}</span>
                          </v-tooltip>
                        </v-row>
                      </v-card-subtitle>
                      <v-divider
                        v-if="j + 1 < timeSubsByTask[taskId].length"
                      ></v-divider>
                    </v-card>
                    <v-row>
                      <v-col>
                        <span class="overline">Expenses</span>
                      </v-col>
                    </v-row>
                    <v-card
                      flat
                      tile
                      light
                      v-for="(expenseSub, k) of expenseSubsByTask[taskId]"
                      :key="k"
                    >
                      <v-card-title>
                        <v-row align="center" no-gutters>
                          <v-col cols="5">
                            <span class="subtitle-2">
                              {{
                                formatDate(
                                  expenseSubmissionStoreData[expenseSub.id]
                                    .date,
                                  'ddd, MMM. D'
                                )
                              }}
                            </span>
                          </v-col>
                          <v-col cols="5">
                            <span class="subtitle-2">
                              ${{
                                expenseSubmissionStoreData[
                                  expenseSub.id
                                ].cost.toFixed(2)
                              }}
                            </span>
                            <v-icon
                              v-if="
                                expenseSubmissionStoreData[expenseSub.id]
                                  .reimburse == true
                              "
                              >mdi-cash-refund</v-icon
                            >
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                x-small
                                icon
                                class="ma-2"
                                color="primary"
                                @click.stop="
                                  loadExpenseForm(
                                    'Edit',
                                    expenseSubmissionStoreData[expenseSub.id]
                                  )
                                "
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit Expense Submission</span>
                          </v-tooltip>
                        </v-row>
                      </v-card-title>
                      <v-card-subtitle>
                        <v-row dense no-gutters align="center">
                          <v-tooltip
                            right
                            v-if="
                              expenseSubmissionStoreData[expenseSub.id]
                                .s3FilePath != null
                            "
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                x-small
                                icon
                                class="ma-2"
                                color="primary"
                                @click.stop="
                                  getSubmissionImage(
                                    expenseSubmissionStoreData[expenseSub.id]
                                  )
                                "
                              >
                                <v-icon>{{
                                  expenseSubmissionStoreData[
                                    expenseSub.id
                                  ].s3FileContentType.split('/')[0] == 'image'
                                    ? 'mdi-image'
                                    : 'mdi-paperclip'
                                }}</v-icon>
                              </v-btn>
                            </template>
                            <span>View Receipt</span>
                          </v-tooltip>
                          {{
                            expenseSubmissionStoreData[expenseSub.id]
                              .description
                          }}
                          <v-spacer></v-spacer>
                          <v-tooltip left v-if="teamView == true">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                class="ma-2"
                                x-small
                              >
                                {{
                                  userStoreData[expenseSub.userId].name.split(
                                    ' '
                                  )[0][0] +
                                    userStoreData[expenseSub.userId].name.split(
                                      ' '
                                    )[1][0]
                                }}
                              </v-chip>
                            </template>
                            <span>{{
                              userStoreData[expenseSub.userId].name
                            }}</span>
                          </v-tooltip>
                        </v-row>
                      </v-card-subtitle>
                      <v-divider
                        v-if="k + 1 < expenseSubsByTask[taskId].length"
                      ></v-divider>
                    </v-card>
                    <v-row>
                      <v-spacer></v-spacer>
                      <v-btn
                        small
                        text
                        color="primary"
                        @click.stop="loadSubmissionDialog(taskId)"
                      >
                        View All
                      </v-btn>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="showTimeForm"
      v-if="showTimeForm == true"
      max-width="800px"
    >
      <DialogForm
        :userid="submitUserId"
        :action="formAction"
        title="Time Submission"
        :data="timeData"
        @update-table="refreshSubs"
        @delete-item="formAction = 'Delete'"
        @success="successHandler"
        @close="showTimeForm = false"
      ></DialogForm>
    </v-dialog>
    <v-dialog
      v-model="showExpenseForm"
      v-if="showExpenseForm == true"
      max-width="800px"
    >
      <DialogForm
        :userid="submitUserId"
        :action="formAction"
        title="Expense Submission"
        :data="expenseData"
        @update-table="refreshSubs"
        @delete-item="formAction = 'Delete'"
        @success="successHandler"
        @close="showExpenseForm = false"
      ></DialogForm>
    </v-dialog>
    <v-dialog
      v-model="showFileDialog"
      v-if="showFileDialog == true"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            class="ma-2"
            color="red"
            @click="showFileDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <v-img :src="fileLink" contain>
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showSubmissionDialog"
      v-if="showSubmissionDialog == true"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          {{ taskStoreData[taskToLoad].name }}
          <v-spacer></v-spacer>
          <v-btn
            x-small
            icon
            class="ma-2"
            color="red"
            @click="showSubmissionDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-container>
                <DataTable
                  sortby="date"
                  title="Time Submissions"
                  :items="submissions[taskToLoad].time"
                  :headers="timeSubmissionHeaders"
                  :loading="loadingTimeSubs"
                  :showadd="false"
                  :showdaterange="false"
                  @error="errorMessage = $event"
                >
                </DataTable>
              </v-container>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-container>
                <DataTable
                  sortby="date"
                  title="Expense Submissions"
                  :items="submissions[taskToLoad].expenses"
                  :headers="expenseSubmissionHeaders"
                  :loading="loadingExpenseSubs"
                  :showadd="false"
                  :showdaterange="false"
                  @error="errorMessage = $event"
                >
                </DataTable>
              </v-container>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from 'moment'
import DataTable from '@/components/DataTable/DataTable.vue'
import DialogForm from '@/components/DialogForm/DialogForm.vue'
export default {
  name: 'Dashboard',
  components: { DialogForm, DataTable },
  data: () => ({
    pageName: 'Dashboard',
    showTimeForm: false,
    showExpenseForm: false,
    formAction: null,
    expenseData: null,
    timeData: null,
    loading: false,
    loadingText: null,
    successMessage: null,
    errorMessage: null,
    dialogSuccessMessage: null,
    dialogErrorMessage: null,
    sortedTasks: [],
    timeSubsByTask: {},
    expenseSubsByTask: {},
    showFileDialog: false,
    fileLink: null,
    teamView: false,
    setUser: null,
    taskToLoad: null,
    loadingTimeSubs: false,
    loadingExpenseSubs: true,
    showSubmissionDialog: false,
    submissions: {},
  }),
  computed: {
    projectStoreData() {
      return this.$store.getters.getProjects
    },
    userStoreData() {
      return this.$store.getters.getUsers
    },
    taskStoreData() {
      return this.$store.getters.getTasks
    },
    timeSubmissionStoreData() {
      return this.$store.getters.getTimeSubmissions
    },
    expenseSubmissionStoreData() {
      return this.$store.getters.getExpenseSubmissions
    },
    timeSubmissionHeaders() {
      let headers = []
      if (this.loggedInUser.type == 'Admin') {
        headers = [
          {
            text: 'Date',
            align: 'left',
            value: 'date',
            sortable: true,
          },
          { text: 'User', value: 'userName', sortable: false },
          { text: 'Duration', value: 'duration', sortable: false },
          { text: 'Rate', value: 'rate', sortable: false },
          { text: 'Notes', value: 'description', sortable: false },
          { text: 'Attachment', value: 'attachment', sortable: false },
        ]
      } else {
        headers = [
          {
            text: 'Date',
            align: 'left',
            value: 'date',
            sortable: true,
          },
          { text: 'User', value: 'userName', sortable: false },
          { text: 'Duration', value: 'duration', sortable: false },
          { text: 'Notes', value: 'description', sortable: false },
          { text: 'Attachment', value: 'attachment', sortable: false },
        ]
      }
      return headers
    },
    expenseSubmissionHeaders() {
      let headers = []
      if (this.loggedInUser.type == 'Admin') {
        headers = [
          {
            text: 'Date',
            align: 'left',
            value: 'date',
            sortable: true,
          },
          { text: 'User', value: 'userName', sortable: false },
          { text: 'Cost', value: 'cost', sortable: false },
          { text: 'Billed Amount', value: 'billedAmount', sortable: false },
          { text: 'Description', value: 'description', sortable: false },
          { text: 'Attachment', value: 'attachment', sortable: false },
        ]
      } else {
        headers = [
          {
            text: 'Date',
            align: 'left',
            value: 'date',
            sortable: true,
          },
          { text: 'User', value: 'userName', sortable: false },
          { text: 'Cost', value: 'cost', sortable: false },
          { text: 'Description', value: 'description', sortable: false },
          { text: 'Attachment', value: 'attachment', sortable: false },
        ]
      }
      return headers
    },
    timeBalances() {
      let balances = {}
      for (var timeSub of Object.values(this.timeSubmissionStoreData)) {
        if (balances[timeSub.userId] == null) {
          balances[timeSub.userId] = timeSub.duration
        } else {
          balances[timeSub.userId] = balances[timeSub.userId] + timeSub.duration
        }
      }
      return balances
    },
    expenseBalances() {
      let balances = {}
      for (var expenseSub of Object.values(this.expenseSubmissionStoreData)) {
        if (balances[expenseSub.userId] == null) {
          balances[expenseSub.userId] = expenseSub.cost
        } else {
          balances[expenseSub.userId] =
            balances[expenseSub.userId] + expenseSub.cost
        }
      }
      return balances
    },
    taskBalances() {
      let balanceByTask = {}
      balanceByTask.totalHours = 0
      balanceByTask.totalExpenses = 0
      for (var task of Object.keys(this.timeSubsByTask)) {
        balanceByTask[task] = { hours: 0, expenses: 0 }
        for (var timeSub of this.timeSubsByTask[task]) {
          if (
            this.teamView == false &&
            timeSub.userId != this.loggedInUser.id
          ) {
            continue
          }
          balanceByTask[task].hours =
            balanceByTask[task].hours + timeSub.duration
        }
        balanceByTask.totalHours =
          balanceByTask.totalHours + balanceByTask[task].hours
      }
      return balanceByTask
    },
    companyId() {
      return this.$store.getters.getCompanyId
    },
    currentWeek() {
      return this.$store.getters.getCurrentWeek
    },
    loggedInUser() {
      return this.$store.getters.getLoggedInUser
    },
    submitUserId() {
      return this.userid != null ? this.userid : this.loggedInUser.id
    },
    pagePermission() {
      let pagePermission = this.$store.getters.getPagePermission
      for (var i = 0; i < pagePermission.length; i++) {
        if (this.pageName == pagePermission[i]) {
          return true
        }
      }
      return false
    },
  },
  watch: {
    taskStoreData() {
      this.refreshTasks()
      this.refreshSubs()
    },
    timeSubmissionStoreData() {
      this.refreshSubs()
    },
    expenseSubmissionStoreData() {
      this.refreshSubs()
    },
    teamView() {
      this.refreshTasks()
      this.refreshSubs()
    },
    setUser() {
      this.refreshTasks()
      this.refreshSubs()
    },
    loggedInUser(newVal, oldVal) {
      if (newVal != null && oldVal == null) {
        this.refreshTasks()
        this.refreshSubs()
      }
    },
  },
  methods: {
    successHandler(message) {
      var self = this
      self.successMessage = message
      self.showTimeForm = false
      self.showExpenseForm = false
      setTimeout(function() {
        self.successMessage = null
      }, 2000)
    },
    refreshTasks() {
      let tasks = []
      if (this.teamView == false && this.loggedInUser != null) {
        for (var taskId of this.loggedInUser.tasks) {
          tasks.push(this.taskStoreData[taskId])
        }
      } else {
        if (this.setUser != null) {
          for (var tId of this.userStoreData[this.setUser].tasks) {
            tasks.push(this.taskStoreData[tId])
          }
        } else {
          tasks = Object.values(this.taskStoreData)
        }
      }
      tasks = tasks.sort(function(a, b) {
        return new Date(a.completionDate) - new Date(b.completionDate)
      })
      this.sortedTasks = []
      for (var task of tasks) {
        if (this.taskStoreData[task.id].completed == false) {
          this.sortedTasks.push(task.id)
        }
      }
    },
    loadSubmissionDialog(tId) {
      this.taskToLoad = tId
      this.loadingTimeSubs = true
      this.loadingExpenseSubs = true
      this.showSubmissionDialog = true
      this.loadSubmissions(tId)
    },
    loadSubmissions(taskId) {
      if (this.submissions[taskId] == null) {
        this.submissions[taskId] = { time: [], expenses: [] }
        let payload = {
          taskId: taskId,
        }
        let self = this
        self.$store.dispatch('getTimeSubmissions', payload).then(result => {
          if (result.success != true) {
            self.errorMessage = result.data.error.message
          } else {
            for (var timeSubmission of result.data) {
              if (self.userStoreData[timeSubmission.userId] != null) {
                timeSubmission.userName =
                  self.userStoreData[timeSubmission.userId].name
              }
            }
            self.submissions[taskId].time = result.data
            self.loadingTimeSubs = false
          }
        })
        self.$store.dispatch('getExpenseSubmissions', payload).then(result => {
          if (result.success != true) {
            self.errorMessage = result.data.error.message
          } else {
            for (var expenseSubmission of result.data) {
              if (self.userStoreData[expenseSubmission.userId] != null) {
                expenseSubmission.userName =
                  self.userStoreData[expenseSubmission.userId].name
              }
            }
            self.submissions[taskId].expenses = result.data
            self.loadingExpenseSubs = false
          }
        })
      } else {
        this.loadingTimeSubs = false
        this.loadingExpenseSubs = false
      }
    },
    refreshSubs() {
      this.timeSubsByTask = {}
      this.expenseSubsByTask = {}
      for (var taskId of Object.keys(this.taskStoreData)) {
        this.timeSubsByTask[taskId] = []
        this.expenseSubsByTask[taskId] = []
      }
      for (var timeSub of Object.values(this.timeSubmissionStoreData)) {
        this.timeSubsByTask[timeSub.taskId].push(timeSub)
      }
      for (var expenseSub of Object.values(this.expenseSubmissionStoreData)) {
        this.expenseSubsByTask[expenseSub.taskId].push(expenseSub)
      }
      for (let tId of Object.keys(this.timeSubsByTask)) {
        this.timeSubsByTask[tId] = this.timeSubsByTask[tId].sort(function(
          a,
          b
        ) {
          return new Date(a.date) - new Date(b.date)
        })
      }
      for (let tId of Object.keys(this.expenseSubsByTask)) {
        this.expenseSubsByTask[tId] = this.expenseSubsByTask[tId].sort(function(
          a,
          b
        ) {
          return new Date(a.date) - new Date(b.date)
        })
      }
    },
    formatDate(date, format) {
      return moment(date).format(format)
    },
    getSubmissionImage(item) {
      let payload = {
        action: 'getObject',
        path: item.s3FilePath,
      }
      let fileArr = item.s3FilePath.split('/')
      this.s3ImageName = fileArr[fileArr.length - 1]
      this.s3ImageContentType = item.s3FileContentType
      let self = this

      self.$store.dispatch('getPresignedUrl', payload).then(result => {
        if (result.success == false) {
          self.errorMessage = result.data.error.message
        } else {
          if (item.s3FileContentType.split('/')[0] == 'image') {
            self.fileLink = result.data
            self.showFileDialog = true
          } else {
            window.open(result.data, '_blank')
          }
        }
      })
    },
    loadTimeForm(action, item) {
      this.formAction = action
      if (item != null) {
        this.timeData = JSON.parse(JSON.stringify(item))
      }
      this.showTimeForm = true
    },
    loadExpenseForm(action, item) {
      this.formAction = action
      if (item != null) {
        this.expenseData = JSON.parse(JSON.stringify(item))
      }
      this.showExpenseForm = true
    },
    resetErrors() {
      this.errorMessage = null
      this.successMessage = null
      this.dialogSuccessMessage = null
      this.dialogErrorMessage = null
    },
  },
  beforeMount() {
    if (this.loggedInUser != null) {
      this.refreshTasks()
      this.refreshSubs()
    }
  },
}
</script>
